const duration = 400;

export default {
  leave({ current }) {
    return new Promise((resolve) => {
      const title = current.container.querySelector("h1");
      const packshot = current.container.querySelector("[data-packshot]");

      if (title) {
        title.style.transition = `all ${duration}ms`;
        title.style.transform = "translateY(-50px)";
      }

      if (packshot) {
        packshot.style.transition = `all ${duration}ms`;
        packshot.style.transform = "translateY(-100px)";
      }

      current.container.style.transition = `all ${duration}ms`;
      current.container.style.opacity = "0";

      setTimeout(resolve, duration);
    });
  },
  enter({ next }) {
    next.container.style.opacity = "0";

    return new Promise((resolve) => {
      setTimeout(() => {
        next.container.style.transition = `all ${duration}ms`;
        next.container.style.opacity = "1";

        setTimeout(resolve, duration);
      });
    });
  },
};
